import { useEffect, useState } from 'react';

/**
 * 웹에서 현재 페이지가 포그라운드(visible)인지 판별하는 훅
 * - Page Visibility API 사용
 *
 * NOTE: react-native-web의 AppState도 내부적으로 Page Visibility API를 사용하므로
 * 네이티브 구현을 그대로 써도 동작한다. 이 파일은 NativeEventEmitter /
 * NativeModules 의존 체인을 차단하고 번들 크기를 줄이기 위해 별도로 존재한다.
 */
export const useIsForegroundNow = () => {
  const [isForeground, setIsForeground] = useState(() =>
    typeof document !== 'undefined'
      ? document.visibilityState === 'visible'
      : true,
  );

  useEffect(() => {
    const handler = () => {
      setIsForeground(document.visibilityState === 'visible');
    };
    document.addEventListener('visibilitychange', handler);
    return () => document.removeEventListener('visibilitychange', handler);
  }, []);

  return isForeground;
};
